import React from 'react';
import AvailableOffers from './containers/AvailableOffers';

const AvailableOffersRoot = ({ rootElement }) => (
  <AvailableOffers rootElement={rootElement} />
);

export default AvailableOffersRoot;